import { defineQuery } from 'next-sanity'
import { inlineCtaFields } from '../atoms'

export const careersAfterHeroBlockFields = `
  _id,
  _type,
  heading,
  mainText,
  buttonLink {
    ${inlineCtaFields}
  },
  wide,
  backgroundColor
`

export const CAREERS_AFTER_HERO_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-after-hero-block"][0]{
    ${careersAfterHeroBlockFields}
  }
`)
